import {
  FundRecommendationResponse,
  FundType,
} from "@rentablo/api/recommender";
import { FilterValue } from "@components/filters/types";

export const filterRecommendationsByType = (
  recommendations: FundRecommendationResponse[] | undefined,
  selectedTypes: FilterValue[]
) => {
  if (selectedTypes.includes("all")) return recommendations;
  return recommendations?.filter((recommendation) =>
    selectedTypes.includes(recommendation.fund.fund_type as string)
  );
};

export const getVisibleRecommendations = (
  filteredRecommendations: FundRecommendationResponse[] | undefined,
  showMore: boolean
) => {
  const shouldShowAll = showMore || (filteredRecommendations?.length ?? 0) <= 3;
  return shouldShowAll
    ? (filteredRecommendations ?? [])
    : (filteredRecommendations?.slice(0, 3) ?? []);
};

export const getUniqueTypes = (
  recommendations: FundRecommendationResponse[] | undefined
) => {
  return recommendations?.reduce(
    (acc, recommendation) => acc.add(recommendation.fund.fund_type as FundType),
    new Set<FundType>()
  );
};
